/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2021 Adobe
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
import { useEffect } from 'react';

import { useStorefrontEvents } from './hooks';

// @deprecated, will be moved to @adobe/aem-core-cif-experience-platform-connector
const useReferrerEvent = (props = {}) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const mse = typeof props.mse !== 'undefined' ? props.mse : useStorefrontEvents();

    useEffect(() => {
        if (!document.referrer || !mse) {
            return;
        }

        mse.context.setReferrerUrl({ referrerUrl: document.referrer });
        mse.publish.referrerUrl();
    }, [mse]);
};

export default useReferrerEvent;
